/*!
 * @utiljs/extend 0.1.5 (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/extend/)
 * API http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/extend/doc/api.md
 * Copyright 2017-2019 美团mfe. All Rights Reserved
 * Licensed under MIT (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/extend/LICENSE)
 */

import { isObject, isArray, isFunction } from '@utiljs/is';

function hasOwnProp(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

var assign = isFunction(Object.assign) ? Object.assign :
/* istanbul ignore next */
function assign(target) {
  if (!isObject(target)) {
    throw new TypeError('assign first param must is object');
  }

  for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
    var source = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

    if (isObject(source)) {
      for (var key in source) {
        if (hasOwnProp(source, key)) {
          target[key] = source[key];
        }
      }
    }
  }

  return target;
};
function extend() {
  return assign.apply(void 0, arguments);
}
function extendDeep(target) {
  // 深拷贝
  if (!isObject(target) && !isArray(target)) {
    throw new TypeError('extend target param must is object');
  }

  for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
    var source = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

    for (var name in source) {
      var src = target[name];
      var copy = source[name]; //避免无限循环

      /* istanbul ignore next */

      if (target === copy) {
        continue;
      } // 非可枚举属性

      /* istanbul ignore next */


      if (!hasOwnProp(source, name)) {
        continue;
      }

      var copyIsArr = void 0;

      if (copy && (isObject(copy) || (copyIsArr = isArray(copy)))) {
        var clone = void 0;

        if (copyIsArr) {
          clone = src && isArray(src) ? src : [];
        } else {
          clone = src && isObject(src) ? src : {};
        }

        target[name] = extendDeep(clone, copy);
      } else if (typeof copy !== 'undefined') {
        target[name] = copy;
      }
    }
  }

  return target;
}

export { assign, extend, extendDeep };
